import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import { EscalateIssueModule } from '@/modules/support/escalate-issue';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const escalateIssueSearchSchema = z.object({
  page: z.number().optional(),
  limit: z.number().optional(),
  escalationId: z.string().optional(),
  status: z.enum(['OPEN', 'IN_PROGRESS', 'RESOLVED']).optional(),
  assignedTeam: z
    .enum(['BUSINESS', 'ENGINEERING', 'GAME_OPS', 'SHOP_OPS'])
    .optional(),
  userId: z.coerce.string().optional(),
  issueCategory: z
    .enum([
      'Top-up',
      'Withdraw',
      'Conversion',
      'Referral',
      'Risk',
      'digigold',
      'App not working',
      'Refund not received',
      'Any kind of bug or game related issue',
      'Incorrect points/rewards',
      'Line-up issue',
      'Deadline issue',
      'Unable to edit team',
      'Winnings not added',
      'Feedback',
      'Damaged/wrong product',
      'Order Delay',
      'RTO',
      'Refund related',
      'Tracking ID not generated',
      'Cancel/Reject',
      'Voucher not received',
      'Unable to Redeem Voucher',
      'Delivery Failed',
      'Out of stock',
      'Delivered but product not received',
      'Incorrect Address',
      'Unable to Buy product',
    ])
    .optional(),
});

export const Route = createFileRoute('/dashboard/support/escalate-issue')({
  validateSearch: escalateIssueSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { canAccessSupportDashboard } = useAccessControl();
  if (!canAccessSupportDashboard) {
    return <AccessDenied />;
  }
  return <EscalateIssueModule />;
}
